__turbopack_context__.v({
  "left-column": "CoreSiteSearch-module-scss-module__OY8UNq__left-column",
  "load-more-trigger": "CoreSiteSearch-module-scss-module__OY8UNq__load-more-trigger",
  "main": "CoreSiteSearch-module-scss-module__OY8UNq__main",
  "results-count": "CoreSiteSearch-module-scss-module__OY8UNq__results-count",
  "right-column": "CoreSiteSearch-module-scss-module__OY8UNq__right-column",
  "section": "CoreSiteSearch-module-scss-module__OY8UNq__section",
  "section-empty": "CoreSiteSearch-module-scss-module__OY8UNq__section-empty",
  "section-header": "CoreSiteSearch-module-scss-module__OY8UNq__section-header",
  "section-meta": "CoreSiteSearch-module-scss-module__OY8UNq__section-meta",
  "section-title": "CoreSiteSearch-module-scss-module__OY8UNq__section-title",
  "sections": "CoreSiteSearch-module-scss-module__OY8UNq__sections",
});
